"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addContactClearWarnings = exports.addContactSetWarning = exports.AddContactWarningMessage = exports.AddContactWarningSlot = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
var AddContactWarningSlot;
(function (AddContactWarningSlot) {
    AddContactWarningSlot["EMAIL_SEND_CODE"] = "EMAIL_SEND_CODE";
    AddContactWarningSlot["EMAIL_EXCHANGE_CODE"] = "EMAIL_EXCHANGE_CODE";
    AddContactWarningSlot["EMAIL_RESEND_CODE"] = "EMAIL_RESEND_CODE";
    AddContactWarningSlot["PHONE_SEND_CODE"] = "PHONE_SEND_CODE";
    AddContactWarningSlot["PHONE_EXCHANGE_CODE"] = "PHONE_EXCHANGE_CODE";
    AddContactWarningSlot["PHONE_RESEND_CODE"] = "PHONE_RESEND_CODE";
})(AddContactWarningSlot = exports.AddContactWarningSlot || (exports.AddContactWarningSlot = {}));
exports.AddContactWarningMessage = {
    EMAIL_SEND_CODE: "Couldn't send code to the email",
    EMAIL_EXCHANGE_CODE: "Couldn't exchange code",
    EMAIL_RESEND_CODE: "Couldn't send the message",
    EMAIL_RESEND_CODE_TOO_SOON: 'The email was sent too recently. Try again in a couple of minutes',
    PHONE_SEND_CODE: "Couldn't send code to the phone number",
    PHONE_EXCHANGE_CODE: "Couldn't exchange code",
    PHONE_RESEND_CODE: "Couldn't send the code",
    PHONE_RESEND_CODE_TOO_SOON: 'The code was sent too recently. Try again in a couple of minutes',
};
exports.addContactSetWarning = (0, toolkit_1.createAction)('ADD_CONTACT/SET_WARNING');
exports.addContactClearWarnings = (0, toolkit_1.createAction)('ADD_CONTACT/CLEAR_WARNINGS');
